(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["performance"] && !Shopify.designMode) return;
  try {
    class PerfStats extends HTMLElement {
    #fired = false;

    connectedCallback() {
      const details = this.querySelector('.details');
      if (!details) return;

      let inView = false;

      const observer = new IntersectionObserver(([entry]) => {
        inView = entry.isIntersecting;
        if (inView && details.open) this.#fire(observer);
      }, { threshold: 0.15 });
      observer.observe(this);

      details.addEventListener('toggle', () => {
        if (details.open && inView) this.#fire(observer);
      });
    }

    #fire(observer) {
      if (this.#fired) return;
      this.#fired = true;
      observer.disconnect();
      setTimeout(() => this._glitch(), 500);
    }

    _glitch() {
      this.querySelectorAll('.perf-stat').forEach((stat, si) => {
        stat.querySelectorAll('.perf-stat__seg--on').forEach((seg, sj) => {
          seg.style.setProperty('--pd', `${200 + si * 50 + sj * 95}ms`);
          seg.classList.remove('perf-seg--glitch');
          void seg.offsetWidth;
          seg.classList.add('perf-seg--glitch');
        });
      });
    }
  }

  if (!customElements.get('perf-stats')) {
    customElements.define('perf-stats', PerfStats);
  }
  } catch(e) { console.error(e); }
})();

})();
